// import { callPromise } from '../utils';
import { WEBP_MINI, flags } from '../constant';

// Webp 支持检查
// TODO: 需要主动调用（文档中说明）
export const webpCheck = () => new Promise<boolean>((r) => {
  if (flags.isSupportWebp !== undefined) {
    return r(flags.isSupportWebp);
  }
  const webP = new Image();
  webP.src = WEBP_MINI;
  const handle = () => {
    flags.isSupportWebp = webP.height === 2;
    r(flags.isSupportWebp);
  };
  webP.onload = handle;
  webP.onerror = handle;
  setTimeout(handle, 2000); // 2s 超时
});
export const isSupportWebp = () => !!flags.isSupportWebp;

// webpCheck().then(d => (supportWebp = d));

// callPromise({ dataSource: webpCheck, timeout: 2000 })
//   .then(d => (supportWebp = d))
//   .catch(() => {
//     console.log('webp 检测超时');
//   });
